<app-filter-panel [fields]="fieldsConfig" (search)="search()"></app-filter-panel>

<!--
<div class="flex gap-2 cola-4">
    <span class="w-full input-field p-input-icon-right">
        <input pInputText placeholder="Nombre" [(ngModel)]="filters.name.value" (keydown.enter)="search()"
            class="w-full" />
        <i *ngIf="filters.name.value" class="pi pi-times cursor-pointer"
            (click)="filters.name.value = null; search()"></i>
    </span>

    <div class="input-field" style="width: 250px;">
        <p-dropdown placeholder="Todos los roles" [options]="roles" optionLabel="title" optionValue="id"
            [(ngModel)]="filters.roleId.value" (onChange)="search()" showClear />
    </div>

    <div class="input-field" style="width: 180px;">
        <p-dropdown placeholder="Activos" [options]="activeOptions" optionLabel="name" optionValue="id"
            [(ngModel)]="filters.active.value" (onChange)="search()"></p-dropdown>
    </div>
    
    <div class="input-field" style="width: 200px;">
        <p-dropdown placeholder="Todos" [options]="absenceOptions" optionLabel="name" optionValue="id"
            [(ngModel)]="filters.absence.value" (onChange)="search()" showClear />
    </div>
    <div *ngIf="isTeamLeader" class="input-field" style="width: 200px;display:flex;align-items: center;">
        <p-checkbox [(ngModel)]="isList" [binary]="true"  id="isList" (onChange)="search()" d-form-field-error></p-checkbox>
        <label for="isList" style="margin-right: 8px;">Ver solo mi equipo</label>        
    </div>
</div>
-->

<p-table #grid [value]="users" [lazy]="true" (onLazyLoad)="loadData($event)" [loading]="loading"
    [paginator]="true" [rows]="25" [totalRecords]="totalRecords" [showCurrentPageReport]="true"
    currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
    [rowsPerPageOptions]="[25,100,250]" [scrollable]="true" scrollHeight="flex" paginatorDropdownAppendTo="body">
    <ng-template pTemplate="header" let-columns>
        <tr>
            <th pSortableColumn="name">Nombre <p-sortIcon field="name" /></th>
            <th pSortableColumn="userName" width="250">Nombre de usuario <p-sortIcon field="userName" /></th>
            <th pSortableColumn="email" width="300">Email <p-sortIcon field="email" /></th>
            <th width="220">Rol</th>
            <th pSortableColumn="active" width="150">Activo <p-sortIcon field="active" /></th>
            <th pSortableColumn="absence" width="150">Ausente <p-sortIcon field="absence" /></th>
            <th width="100"></th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-user let-columns="columns">
        <tr (dblclick)="edit(user)">
            <td>{{user.name}}</td>
            <td>{{user.userName}}</td>
            <td>{{user.email}}</td>
            <td>{{user.role?.title}}</td>
            <td>
                <p-checkbox [(ngModel)]="user.active" (onChange)="setActive(user)" [binary]="true"></p-checkbox>
            </td>
            <td>
                <!--<i class="pi" [ngClass]="{ 'text-red-500 pi-check-circle': user.absence, 'text-green-500': !user.absence }"></i>-->
                <p-checkbox styleClass="p-absence-checkbox" [(ngModel)]="user.absence" (onChange)="setAusence(user)" [binary]="true"></p-checkbox>
            </td>
            <td>
                <div class="flex gap-2 justify-content-end">
                    <p-button *ngIf="allowDelete" (click)="delete(user)" [rounded]="true" [text]="false"
                        severity="danger"><i class="pi pi-trash"></i></p-button>
                    <p-button *ngIf="allowWrite" (click)="edit(user)" [rounded]="true" [text]="false"><i
                            class="pi pi-pencil"></i></p-button>
                </div>
            </td>
        </tr>
    </ng-template>
</p-table>

<p-confirmDialog></p-confirmDialog>